export const GenderOptions = [
  {
    name: 'مرد',
    value: '0',
  },
  {
    name: 'زن',
    value: '1',
  },
];
export const MaritalStatusOptions = [
  {
    name: 'متاهل',
    value: '1',
  },
  {
    name: 'مجرد',
    value: '0',
  },
];

export const MilitaryStatusOption = [
  {
    name: 'انجام شده',
    value: '0',
  },
  {
    name: 'معاف دائم',
    value: '1',
  },
  {
    name: 'معافیت تحصیلی',
    value: '2',
  },
  {
    name: 'در حال انجام',
    value: '3',
  },
  {
    name: 'مشمول',
    value: '4',
  },
];

export const JobGroupOptions = [
  {
    name: 'مشاغل تجاری و فروش',
    value: 'G1',
  },
  {
    name: 'خدماتی',
    value: 'G2',
  },
  {
    name: 'امور حقوقی و اداری',
    value: 'G3',
  },
  {
    name: 'آموزشی و تربیتی',
    value: 'G4',
  },
  {
    name: 'سلامت و روان',
    value: 'G5',
  },
  {
    name: 'صنعتی و فنی',
    value: 'G6',
  },
  {
    name: 'تولیدی و صنایع دستی',
    value: 'G7',
  },
  {
    name: 'فناوری اطلاعات و کسب و کار اینترنتی',
    value: 'G8',
  },
  {
    name: 'بازارهای مالی و امور بانکی',
    value: 'G9',
  },
  {
    name: 'مدیریت و فرماندهی',
    value: 'G10',
  },
  {
    name: 'فرهنگ و هنر',
    value: 'G11',
  },
  {
    name: 'کارآفرینی',
    value: 'G12',
  },
];
